import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ref, onValue, query, orderByChild, equalTo, get } from "firebase/database";
import { db } from "../../../../assets/firebase/firebaseconfig";
import "react-quill-new/dist/quill.snow.css";
import "./styles.css";
import { Helmet } from "react-helmet-async";
import Info from "../../../../assets/js/info";
import { createSlug } from "../../../../assets/js/slug";

const NewsDetail = () => {
  const { slug } = useParams(); // Lấy slug từ URL thay vì id
  
  const [article, setArticle] = useState(null);
  const [actualId, setActualId] = useState(null); // Lưu ID thực tế để dùng cho stats/comments
  const [relatedNews, setRelatedNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ views: 0, likes: 0, isLiked: false });

  // 1. Lấy dữ liệu bài viết dựa trên SLUG
  useEffect(() => {
    const fetchArticle = async () => {
      try {
        setLoading(true);
        const newsRef = ref(db, "news");
        
        // Truy vấn tìm bài viết có field slug khớp với URL
        const q = query(newsRef, orderByChild("slug"), equalTo(slug));
        const snapshot = await get(q);

        if (snapshot.exists()) {
          const data = snapshot.val();
          const id = Object.keys(data)[0]; // Lấy ID thực tế
          setActualId(id);
          setArticle(data[id]);

          // 2. Lấy tin liên quan (lọc theo bài hiện tại dùng slug)
          const allNewsRef = ref(db, "news");
          onValue(allNewsRef, (allSnapshot) => {
            const allData = allSnapshot.val();
            if (allData) {
              const list = Object.keys(allData)
                .map((key) => ({ id: key, ...allData[key] }))
                .filter((item) => item.slug !== slug) // Lọc bỏ bài đang xem
                .sort((a, b) => b.createdAt - a.createdAt)
                .slice(0, 5);
              setRelatedNews(list);
            }
          });
        } else {
          setArticle(null);
        }
      } catch (error) {
        console.error("Lỗi lấy chi tiết tin tức:", error);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchArticle();
    }
    window.scrollTo(0, 0);
  }, [slug]);

  // 3. Quản lý View và Like qua LocalStorage (Dùng actualId để thống nhất)
  useEffect(() => {
    if (!loading && actualId) {
      const statsKey = `news_stats_${actualId}`;
      const savedStats = JSON.parse(localStorage.getItem(statsKey)) || {
        views: Math.floor(Math.random() * 500) + 100,
        likes: Math.floor(Math.random() * 50),
        isLiked: false,
      };

      const newStats = { ...savedStats, views: savedStats.views + 1 };
      setStats(newStats);
      localStorage.setItem(statsKey, JSON.stringify(newStats));
    }
  }, [actualId, loading]);

  const handleLike = () => {
    const statsKey = `news_stats_${actualId}`;
    let newStats;
    if (stats.isLiked) {
      newStats = { ...stats, likes: stats.likes - 1, isLiked: false };
    } else {
      newStats = { ...stats, likes: stats.likes + 1, isLiked: true };
    }
    setStats(newStats);
    localStorage.setItem(statsKey, JSON.stringify(newStats));
  };

  const handleShareFB = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`, "_blank", "width=600,height=400");
  };

  if (loading) return <div style={{ padding: "15rem", textAlign: "center" }}>Đang tải nội dung...</div>;
  if (!article) return <div style={{ padding: "15rem", textAlign: "center" }}>Không tìm thấy bài viết</div>;

  return (
    <div className="baomoi-detail-wrapper">
      <Helmet>
        <title>{article.title} | Habako M&E</title>
        <meta name="description" content={article.title || article.title.substring(0, 150)} />
       <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "article", // Hoặc "Product" nếu là trang sản phẩm
      "headline": article.title,
      "description": article.description,
      "image": article.image,
      "author": {
        "@type": "Organization",
        "name": "Habako M&E"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Habako M&E",
        "logo": {
          "@type": "ImageObject",
          "url": "https://habakome-6d2ee.web.app/static/media/logo1.bded67026a0b99b52999.png"
        }
      },
      "datePublished": new Date(article.createdAt).toISOString()
    })}
  </script>
      </Helmet>

      <div className="container baomoi-detail-container">
        <article className="baomoi-article-content">
          <nav className="baomoi-breadcrumb">
            <Link to="/">Trang chủ</Link> / <Link to="/tin-tuc">Tin tức</Link> /{" "}
            <span>{article.category}</span>
          </nav>

          <h1 className="baomoi-article-title">{article.title}</h1>

          <div className="baomoi-article-meta">
            <span className="source-name">HABAKO NEWS</span>
            <span className="dot">•</span>
            <span className="publish-date">
              {new Date(article.createdAt).toLocaleDateString("vi-VN")}
            </span>
            <span className="view-count">
              <i className="far fa-eye"></i> {stats.views.toLocaleString()} lượt xem
            </span>
          </div>

          <div className="baomoi-social-plugin">
            <div className="plugin-left">
              <button className={`btn-like-fb ${stats.isLiked ? "liked" : ""}`} onClick={handleLike}>
                <i className={stats.isLiked ? "fas fa-thumbs-up" : "far fa-thumbs-up"}></i>
                Thích <span>{stats.likes}</span>
              </button>
              <button className="btn-share-fb" onClick={handleShareFB}>Chia sẻ</button>
            </div>
            <div className="plugin-right">
              <button className="btn-zalo" onClick={() => window.open(`https://sp.zalo.me/share/base?url=${window.location.href}`)}></button>
              <button className="btn-copy-link" onClick={() => {
                  navigator.clipboard.writeText(window.location.href);
                  alert("Đã sao chép liên kết!");
              }}>
                <i className="fas fa-link"></i>
              </button>
            </div>
          </div>

          <div className="baomoi-article-body">
            <p className="baomoi-article-sapo" style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
              {article.summary}
            </p>

            <figure className="baomoi-article-image">
              <img src={article.image} alt={article.title} />
              <figcaption>Hình ảnh minh họa cho bài viết.</figcaption>
            </figure>

            {/* Hiển thị nội dung chi tiết bài viết */}
            <Info product={article} showFullDescription={true}/>
          </div>

          <div className="baomoi-article-tags">
            <span>Tags:</span>
            <a href="#">#Habako</a> <a href="#">#TinTuc</a>{" "}
            <a href="#">#{article.category?.replace(/\s/g, "")}</a>
          </div>
        </article>

        <aside className="baomoi-article-sidebar">
          <div className="sticky-sidebar">
            <h3 className="sidebar-title">TIN LIÊN QUAN</h3>
            <div className="related-list">
              {relatedNews.map((item) => (
                <Link to={`/tin-tuc/${item.slug || createSlug(item.title)}`} key={item.id} className="related-item">
                  <div className="related-thumb">
                    <img src={item.image} alt={item.title} />
                  </div>
                  <h4>{item.title}</h4>
                </Link>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default NewsDetail;